import { render, staticRenderFns } from "./AppendixVISA.vue?vue&type=template&id=c13f295c&scoped=true"
import script from "./AppendixVISA.vue?vue&type=script&lang=js"
export * from "./AppendixVISA.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c13f295c",
  null
  
)

export default component.exports